import { MDBAlert, MDBBtn, MDBIcon, MDBInputGroup, MDBTabs, MDBTabsItem, MDBTabsLink, MDBTooltip } from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";

import { useLocation, useNavigate } from "react-router";
import Header from "../components/Header";
import LeftPane from "../components/LeftPane";
import Loader from "../components/Loader";
import Popup from "../components/Popup";
import LogATime from "../components/logatime";
import SubPopup from "../components/supPopup";
import Timer from "../components/timer";
import { getCancellationPolicy, getClass, getNewCheckMembers, getPlans, getSchedule, getStaffInfo, searchPartnerGymMembers } from "../services/apiServices.js";
import logtimeImg from "./../components/images/log_timeGreen.svg";
import AttendanceList from "./AttendanceList";
import PageError from "./PageError";
import ClassCheckIn from "./ClassCheckIn";
import ScheduleInvoice from "./Classes/ScheduleInvoice";

import { useAccess } from "../context/AccessContext";

const Check = (props) => {
  const [logtimeShow, setLogtimeShow] = useState(false);
  const [openAttendance, setOpenAttendance] = useState(false);
  const [selData, setSelData] = useState(false);
  const [value, setvalue] = useState("");
  const [apiError, setApiError] = useState(false);
  const [activestatus, setActive] = useState("active");
  const [userData, setData] = useState([]);
  const [selectedId, setSelectedId] = useState(-1);
  const [checkedMembers, setCheckedMembers] = useState([]);
  const [loading, setLoading] = useState(true)
  const [valuee, setValuee] = useState(-1);
  const [Date11, setDate11] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
  const [Date22, setDate22] = useState(new Date());
  const location = useLocation();
  const [searchQuery, setSearchQuery] = useState("");//1
  const [typingTimeout, setTypingTimeout] = useState(0);//2
  const [activepage, setActivepage] = useState("active");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(30);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage1, setCurrentPage1] = useState(1);
  const [itemsPerPage1, setItemsPerPage1] = useState(30);
  const [refresh, setRefresh] = useState(false)
  const navigate = useNavigate();
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertTitle, setAlertTitle] = useState("");
  const [scheduleInfo, setScheduleInfo] = useState([])
  const [classes, setClasses] = useState([])
  const [trainerData, setTrainerData] = useState([])
  const [policyData, setPolicyData] = useState([])
  const [isInvoiceOpen, setIsInvoiceOpen] = useState(false);

  // In Check.js, add these states:
  const [invoiceCheck, setInvoiceCheck] = useState(false);
  const [selectedClassForInvoice, setSelectedClassForInvoice] = useState(null);
  const [selectedMembersForInvoice, setSelectedMembersForInvoice] = useState([]);
  const [discountDataForInvoice, setDiscountDataForInvoice] = useState([]);
  const [bussinessinfo, setBusinessInfo] = useState(null);


  const [plans, setPlans] = useState("");

  // Add this function in Check.js
  const handleClassInvoice = (invoiceData) => {
    const {
      scheduleinfo,
      selectedMembers,
      memeberInfo,
      discountMembers,
      callbackUrl,
      downloadInvoice,
      bussinessinfo
    } = invoiceData;

    setSelectedClassForInvoice(scheduleinfo);
    setSelectedMembersForInvoice(memeberInfo || selectedMembers);
    setDiscountDataForInvoice(discountMembers || []);
    setInvoiceCheck(true);

    setBusinessInfo(bussinessinfo)
    // Store callback and download functions if needed
    if (callbackUrl) {
      window.invoiceCallback = callbackUrl;
    }
    if (downloadInvoice) {
      window.downloadInvoice = downloadInvoice;
    }
  };

  // Callback handler for invoice completion
  const handleInvoiceCallback = () => {
    setInvoiceCheck(false);
    setSelectedClassForInvoice(null);
    setSelectedMembersForInvoice([]);
    setDiscountDataForInvoice([]);
    if (window.invoiceCallback) {
      window.invoiceCallback();
    }
  };


  useEffect(() => {
    if (showAlert) {
      const timer = setTimeout(() => {
        setShowAlert(false);
      }, 3000); // auto close after 3 seconds

      return () => clearTimeout(timer);
    }
  }, [showAlert]);


  let filter = {}

  let inputHandler = (event) => {
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    const sTxt = event.target.value;

    setTypingTimeout(
      setTimeout(() => {
        if (sTxt.trim() !== "") {
          setSearchQuery(sTxt.trim());
          if (activepage === "partnerGym") {
            setCurrentPage(1);
            fetchPartnerGymData(sTxt.trim());
          } else {
            setCurrentPage(activepage === "active" ? 1 : currentPage1);
            fetchData(sTxt.trim());
          }
        } else {
          setSearchQuery("");
          if (activepage === "partnerGym") {
            fetchPartnerGymData("");
          } else {
            fetchData("");
          }
        }
      }, 500)
    );
  };


  const fetchPartnerGymData = async (searchText = "") => {
    if (!searchText.trim()) {
      setData([]);
      setLoading(false);
      setRefresh(false);
      return;
    }
    try {
      setLoading(true);
      const currentGymId = JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid;
      if (!currentGymId) return;

      const updates = {
        currentGymId: currentGymId,
        searchQuery: searchText,
        currentPage: currentPage,
        limit: itemsPerPage
      }

      const response = await searchPartnerGymMembers(
        updates
      );

      const data = await response.json()

      if (response.error) {
        console.error("Partner gym search error:", response.error);
        setData([]);
        setTotalPages(1);
      } else {
        setData(data.paginatedMembers || []);
        setTotalPages(data.totalPages || 1);
        setCurrentPage(page => Math.min(page, data.totalPages || 1));
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching partner gym members:", error);
      setData([]);
      setLoading(false);
    }
    setRefresh(false);
  };




  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const loggedUser = JSON.parse(localStorage.getItem("loggedUserInfo"));

        if (!loggedUser?.gymid) {
          throw new Error("Gym ID not found");
        }

        const planResponse = await getPlans(loggedUser.gymid);

        if (!planResponse || planResponse === "false") {
          setApiError(true);
          return;
        }

        if (!planResponse.ok) {
          throw new Error("Failed to fetch plans");
        }

        const plans = await planResponse.json();

        if (Array.isArray(plans)) {
          setPlans(plans);
        } else {
          setPlans([]);
        }
      } catch (error) {
        console.error("Error fetching plans:", error);
        setApiError(true);
      }
    };

    fetchPlans();
  }, []);



  useEffect(() => {

    const fetchData = async () => {
      const gymid = JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid;
      if (!gymid) return;
      const response = await getSchedule(gymid);
      if (!response || response === "false") {
        return;
      }
      const scheduleinfo = await response.json();

      console.log(scheduleinfo, 'sssssssssss');
      setScheduleInfo(scheduleinfo)
      // setRefresh(false)
    }
    if (localStorage.getItem("loggedUserInfo")) {
      fetchData()
    }


  }, [])


  useEffect(() => {

    const fetchData = async () => {
      const gymid = JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid;
      if (!gymid) return;
      const response = await getClass(gymid);
      if (!response || response === "false") {
        return;
      }
      const classinfo = await response.json();

      console.log(classinfo, 'classsssssssss');
      setClasses(classinfo)


      // setRefresh(false)
    }
    const fetchStaffData = async () => {
      const gymid = JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid;
      if (!gymid) return;
      const trainerres = await getStaffInfo(gymid);
      if (!trainerres || trainerres === "false") {
        return;
      }
      const trainerinfo = await trainerres.json();

      console.log(trainerinfo, 'trainerinfo');
      setTrainerData(trainerinfo)

    }
    const fetchPolicyData = async () => {
      const gymid = JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid;
      if (!gymid) return;
      const res = await getCancellationPolicy(gymid);
      console.log(res);

      if (!res || res === "false") {
        return;
      }
      const policyinfo = await res.json();

      console.log(policyinfo, 'Policyinfo');
      setPolicyData(policyinfo)
    }

    if (localStorage.getItem("loggedUserInfo")) {
      fetchData()
      fetchPolicyData()
      fetchStaffData()
    }


  }, [])




  function openLogTime(e, data, value) {

    const loggedUser = JSON.parse(localStorage.getItem("loggedUserInfo"));
    const partnerGymId = loggedUser?.gymid;
    if (data?.notAllowedCheckin && value !== "Check-Out") {
      const reason = data?.reason?.toLowerCase() || "";
      let title = "Check-In Not Allowed";
      let msg = data?.reason || "This member is not eligible for check-in at this gym.";

      if (data?.isSuspended) {
        title = "Member Suspended";
        msg = "This member is suspended and cannot check in at any partner gym.";
      } else if (reason.includes("paused")) {
        title = "Gym Access Paused";
        msg = "The partnership with this gym is currently paused. Contact the home gym admin to restore access.";
      } else if (reason.includes("no active plan") || reason.includes("expired")) {
        title = "No Active Plan";
        msg = "This member does not have a valid active plan at their home gym.";
      } else if (reason.includes("not allowed") || reason.includes("not eligible")) {
        title = "Plan Not Eligible";
        msg = "This member's current plan is not included in the multi-gym allowed plans list.";
      } else if (reason.includes("no multi-gym")) {
        title = "Multi-Gym Not Configured";
        msg = "The member's home gym has not set up multi-gym access.";
      }

      setAlertTitle(title);
      setAlertMessage(msg);
      setShowAlert(true);
      return;
    }

    if (activepage === "partnerGym") {
      if (data?.notInCurrentGym) {
        navigate('/qrwaiver', {
          state: {
            memberId: data._id?.toString() || null,
            homeGymId: data.bId?._id?.toString() || data.bId?.toString() || null,
            partnerGymId: partnerGymId,
            memberInfo: data,
            checkpage: true
          }
        });
        return;
      }

      // Member exists in current gym but hasn't submitted the partner waiver yet
      if (data?.iswaiververified === false && data?.currentGymMemberId) {
        navigate('/qrwaiver', {
          state: {
            memberId: data.currentGymMemberId?.toString(),
            homeGymId: data.bId?._id?.toString() || data.bId?.toString() || null,
            partnerGymId: partnerGymId,
            memberInfo: { ...data, partnerWaiverRequired: true },
            checkpage: true
          }
        });
        return;
      }
    }
    setSelData(data);
    setvalue(value);
    setLogtimeShow(true);
    setSelectedId(data.memberId);
  }

  function checkMember(updates, member) {
    try {
      console.log(updates);
      let inputDate = new Date(updates.date);
      let currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);
      inputDate.setHours(0, 0, 0, 0);
      setRefresh(true)
    } catch (e) { console.error(e) }
    setLogtimeShow(false);
  }
  console.log(userData)
  function closeLogTime(updates, member) {
    try {
      /**Added newly as per Ranga requirement */
      if (updates.checkFlag === "1") {
        setCheckedMembers([...checkedMembers, member._id])
      } else {
        let tmpmember = checkedMembers.filter((item) => item !== member._id);
        setCheckedMembers(tmpmember)
      }
    } catch (e) { console.error(e) }

    setLogtimeShow(false);
  }
  function closeAttenance() {
    setOpenAttendance(false);
  }
  function viewAttendance(e, data) {
    let tmpmember = checkedMembers.filter((item) => item === data._id);
    console.log(checkedMembers)
    console.log(data._id);
    if (tmpmember && tmpmember.length > 0) {
      data.checkedin = true;
    } else {
      data.checkedin = false;
    }

    setSelData(data);
    setSelectedId(data.memberId);
    setOpenAttendance(true);
    //alert(data._id);
  }
  function getExpiryDate(data) {
    try {
      if (!data.expirydate) return "No Plan";
      let startdate = new Date();
      let enddate = data.expirydate;
      let expirydate = new Date(enddate).getTime() - startdate.getTime();
      let cd = 24 * 60 * 60 * 1000;
      let exdays = Math.floor(expirydate / cd) + 1;

      if (exdays >= 1) {
        return exdays + " Day(s)";
      } else {
        const checkins = data.attendance || [];
        const allowedSessions = data.session?.totalsessions || 0;
        const usedSessions = checkins.length;

        const isOverused = usedSessions > allowedSessions;

        return isOverused ? "Expired (Overdue)" : "Expired";
      }
    } catch (e) {
      console.log(e);
      return "No Plan";
    }
  }
  const usersData = userData
  async function fetchData(sTxt) {
    if (localStorage.getItem("loggedUserInfo")) {
      let search = searchQuery;

      if (sTxt) {
        search = sTxt;
      }
      let date = new Date()
      date.setHours(0, 0, 0, 0);
      if (location && !location.status) {
        location.status = activestatus;
      }
      if (location.status === "active") {
        location.limitmember = itemsPerPage;
        if (currentPage > totalPages) {
          setCurrentPage(1)
        }
        location.currentPage = currentPage > totalPages ? 1 : currentPage;

      } else {
        location.limitmember = itemsPerPage1;
        if (currentPage1 > totalPages) {
          setCurrentPage1(1)
        }
        location.currentPage = currentPage1 > totalPages ? 1 : currentPage1;
      }
      filter.name = search
      location.filter = filter;
      if (location.state === null && valuee !== -1) {
        location.state = {}
        location.state.data = valuee;
        location.state.fdate = Date11;
        location.state.tdate = Date22;
      }

      const gymid = JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid;
      if (!gymid) return;
      const response = await getNewCheckMembers(
        gymid,
        location
      )

      console.log(location);
      if (!response) {
        return;
      }
      if (response === "false") {
        setApiError(true)
      } else {
        const tuserData = !props.internalload
          ? await response.json()
          : props.members;

        if (!tuserData) {
          return;
        }

        setTotalPages(tuserData.totalPages)

        setData(tuserData.paginatedMembers);

        setValuee(location && location.state && location.state.data);
        setDate11(location && location.state && location.state.fdate);
        setDate22(location && location.state && location.state.tdate);
        setLoading(false);
      }
    }
    setRefresh(false)
  }
  useEffect(() => {
    setLoading(true)
    if (activepage !== "partnerGym") {
      fetchData();
    } else {
      fetchPartnerGymData(searchQuery);
    }
  }, [currentPage, currentPage1, itemsPerPage, location, itemsPerPage1, activepage, searchQuery, refresh]);


  // Update tab handlers
  const handleActive = () => {
    setActive("active");
    location.status = "active";
    setActivepage("active");
    setLoading(true);
  };

  const handleInactive = () => {
    setActive("inactive");
    location.status = "inactive";
    setActivepage("inactive");
    setLoading(true);

  };


  const handlePartnerGym = () => {
    setActive("partnerGym");
    location.status = "partnerGym";
    setActivepage("partnerGym");
    setCurrentPage(1);
    setTotalPages(1);
    setLoading(true);
    fetchPartnerGymData(searchQuery);
  };



  const handleClass = () => {
    setActive("class");
    location.status = "class";
    setActivepage("class");
    setLoading(true);
  }

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
    setLoading(true);
  };

  const prevPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
    setLoading(true);
  };



  const nextPage1 = () => {
    if (currentPage1 < totalPages) {
      setCurrentPage1(currentPage1 + 1);
    }
    // fetchData();
  };

  const prevPage1 = () => {
    if (currentPage1 > 0) {
      setCurrentPage1(currentPage1 - 1);
    }
    // fetchData();
  };
  const handleReload = () => {
    window.location.reload();
  }

  const { handlePageAccess } = useAccess();
  const roleAccess = handlePageAccess("checkin")

  return (
    <>
      {!props.internalload && !invoiceCheck && (
        <>
          <LeftPane isactive="5" />
          <Header />
        </>
      )}

      {showAlert && (
        <div className="alert-backdrop">
          <div className="alert-box">
            <div className="d-flex justify-content-between align-items-end">
              <div>
                <strong>{alertTitle || "Check-In Not Allowed"}</strong>
                <div style={{ marginTop: "4px", fontSize: "13px" }}>{alertMessage}</div>
              </div>
            </div>
          </div>
        </div>
      )}

      {apiError ? (
        <PageError handleReload={handleReload} />
      ) : invoiceCheck && selectedClassForInvoice ? (
        <div className="invoice-fullscreen h-100">
          <div className="invoice-header d-flex justify-content-between align-items-center p-3 border-bottom bg-light">
            <h4 className="mb-0">Class Booking Invoice</h4>

          </div>
          <div className="invoice-body checkinoutinvoice p-3 h-100">
            <ScheduleInvoice
              scheduleinfo={selectedClassForInvoice}
              selectedMembers={selectedMembersForInvoice.map(m => m._id)}
              memeberInfo={selectedMembersForInvoice}
              bussinessinfo={bussinessinfo}
              discountMembers={discountDataForInvoice}
              callbackUrl={handleInvoiceCallback}
              downloadInvoice={window.downloadInvoice || (() => { })}
            />
          </div>
        </div>
      ) : (
        <div
          className={
            !props.internalload
              ? "gym-main gym-main-div rightContent"
              : "gym-main rightContent"
          }
          style={{ height: "100vh" }}
        >
          <div className="gym-container gym-cnr" id="showcase">
            <div className="d-flex align-items-center mob-block">
              <h3 className="gym-large m-0">Check-In / Check-Out(s)</h3>
              <div
                className="gym-xlarge gym-text-red d-flex justify-content-between ms-2 check-search"
                style={{ position: "relative" }}
              >
                <MDBInputGroup textAfter={<MDBIcon fas icon="search" />}>
                  <input
                    className="form-control gym-input forminput ms-2"
                    type="text"
                    placeholder="Search Members by Name or Phone"
                    onChange={(event) => inputHandler(event)}
                  />
                </MDBInputGroup>
              </div>
            </div>
            <div className="w-100 d-flex align-items-center justify-content-start">
              <MDBTabs className="mb-3">
                <MDBTabsItem>
                  <MDBTabsLink
                    className={activepage === "active" ? "active" : ""}
                    onClick={handleActive}
                  >
                    Active Members
                  </MDBTabsLink>
                </MDBTabsItem>
                <MDBTabsItem>
                  <MDBTabsLink
                    className={activepage === "inactive" ? "active" : ""}
                    onClick={handleInactive}
                  >
                    Inactive Members
                  </MDBTabsLink>
                </MDBTabsItem>

                <MDBTabsItem>
                  <MDBTabsLink
                    className={activepage === "class" ? "active" : ""}
                    onClick={handleClass}
                  >
                    Class Check-In
                  </MDBTabsLink>
                </MDBTabsItem>

                <MDBTabsItem>
                  <MDBTabsLink
                    className={activepage === "partnerGym" ? "active" : ""}
                    onClick={handlePartnerGym}
                  >
                    Partner check-in
                  </MDBTabsLink>
                </MDBTabsItem>
              </MDBTabs>
            </div>
          </div>

          {activepage === "class" ? (
            <div className="px-3">
              <ClassCheckIn
                scheduleInfo={scheduleInfo}
                classes={classes}
                trainerData={trainerData}
                policyData={policyData}
                usersData={usersData}
                onInvoiceStateChange={setIsInvoiceOpen}
                onInvoiceRequest={handleClassInvoice}
                plans={plans}
              />
            </div>
          ) : (
            <div className="row checksHeight">
              <div className="w-100 h-auto row m-0">
                {usersData && !loading ? (
                  usersData.map((data, index) => (
                    <div className="col-lg-3 col-md-4 col-lp-6" key={index}>
                      <div className="checkinbuttonmain boxpadding">
                        <div className="insidecheck">
                          <div className="d-flex align-items-baseline">
                            <MDBTooltip
                              tag="span"
                              wrapperProps={{ className: "checkIn-Head" }}
                              title={data.fname + " " + data.lname}
                            >
                              {data.fname + " " + data.lname}
                            </MDBTooltip>
                          </div>

                          <span className="mt-1">
                            {(data.sex || data.age || data.weight) && (
                              <span className="me-2">
                                {data.sex ? data.sex[0] : ""}
                                {data.sex && (data.age || data.weight) ? ", " : ""}
                                {data.age ? +data.age + "y" : ""}
                                {data.age && data.weight ? ", " : ""}
                                {data.weight ? +data.weight + "kgs, " : ""}
                              </span>
                            )}
                            Member ID: {data.mid}
                          </span>

                          {!data.issuspend ? (
                            <span className="mt-1">
                              {getExpiryDate(data).includes("Expired") ? (
                                <>
                                  <span className="text-danger">
                                    Plan {getExpiryDate(data)}
                                  </span>
                                  {data?.session ? (
                                    <span className="ms-2">
                                      Sessions:{" "}
                                      <span className="text-success">
                                        {data.session.balsessions}
                                      </span>
                                      /{data.session.totalsessions}
                                    </span>
                                  ) : (
                                    <></>
                                  )}
                                </>
                              ) : getExpiryDate(data).includes("No Plan") ? (
                                <span className="text-danger">
                                  No Plan Associated
                                </span>
                              ) : (
                                <>
                                  <span> Plan Expires:{getExpiryDate(data)}</span>
                                  {data?.session && data?.session?.totalsessions > 0 ? (
                                    <span className="ms-2">
                                      Sessions:{" "}
                                      <span className="text-success">
                                        {data.session.balsessions}
                                      </span>
                                      /{data.session.totalsessions}
                                    </span>
                                  ) : (
                                    <></>
                                  )}
                                </>
                              )}
                            </span>
                          ) : (
                            <label className="text-danger mt-1">
                              Member Suspended
                            </label>
                          )}

                          <span className="mt-1">
                            <button
                              type="button"
                              className="P-0 button-link link-color"
                              onClick={(e) => viewAttendance(e, data)}
                            >
                              View Attendance
                            </button>
                          </span>
                        </div>
                        {!data.issuspend && (
                          <div className="log-expire">
                            <div
                              style={{ cursor: "pointer" }}
                              className={
                                data.checkinflag === 1
                                  ? "checkindate checkinbuttonout"
                                  : "checkindate"
                              }
                              onClick={(e) =>
                                openLogTime(
                                  e,
                                  data,
                                  data.checkinflag === 1
                                    ? "Check-Out"
                                    : "Check-In"
                                )
                              }
                            >
                              <input
                                type="button"
                                value={
                                  data.checkinflag === 1
                                    ? "Check-Out"
                                    : "Check-In"
                                }
                                className={
                                  data.checkinflag === 1
                                    ? "checkinbuttonout"
                                    : getExpiryDate(data).includes("Day")
                                      ? "checkinbutton"
                                      : "ExpiredCheckin"
                                }
                              />

                              {data.checkinflag === 1 && (
                                <p className="d-flex m-inherit f-9">
                                  <Timer
                                    member={data.fname}
                                    time={new Date(data.checkindate)}
                                  />
                                  &nbsp;
                                </p>
                              )}
                            </div>

                            <span
                              className="logtime pt-1 pb-1 text-end"
                              data-mdb-toggle="modal"
                              data-mdb-target="#logtime"
                              onClick={(e) => openLogTime(e, data, "Log Time")}
                            >
                              &nbsp;
                              <img
                                className="w-16 logaTimeIcon"
                                src={logtimeImg}
                                alt="logatime"
                              />
                              &nbsp; Log Time
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="loader-height">
                    <Loader />
                  </div>
                )}

                {!loading && usersData && usersData.length === 0 &&
                  (activepage === "partnerGym" ? (
                    searchQuery.trim()
                      ? <>No members found with multi-gym access</>
                      : <>Search by name or phone to find partner gym members</>
                  ) : (
                    <>No member found to check-in</>
                  ))}
              </div>
            </div>
          )}

          {activepage === "active" && !invoiceCheck && (
            <>
              <div className="datatable-pagination">
                Rows per page
                <div className="ms-2 form-control w-auto">
                  <select
                    value={itemsPerPage}
                    onChange={(e) => {
                      setItemsPerPage(Number(e.target.value));
                    }}
                    className="Pagenation-Select"
                  >
                    <option value="30">
                      <div className="select-option">30</div>
                    </option>
                    <option value="50">
                      <div className="select-option">50</div>
                    </option>
                    <option value="100">
                      <div className="select-option">100</div>
                    </option>
                    <option value="500">
                      <div className="select-option">500</div>
                    </option>
                    <option value="1000">
                      <div className="select-option">1000</div>
                    </option>
                  </select>
                </div>
                <button
                  onClick={prevPage}
                  disabled={currentPage === 1}
                  className="btn btn-link datatable-pagination-button datatable-pagination-right ripple-surface-dark"
                >
                  Previous
                </button>
                <div className="d-flex justify-content-between w-120px align-items-center">
                  {" "}
                  Page
                  <input
                    className="form-control w-50px"
                    value={currentPage}
                    onChange={(e) => setCurrentPage(Number(e.target.value))}
                  />
                  of {totalPages}
                </div>
                <button
                  onClick={nextPage}
                  disabled={currentPage === totalPages}
                  className="btn btn-link datatable-pagination-button datatable-pagination-right ripple-surface-dark"
                >
                  Next
                </button>
              </div>
            </>
          )}

          {activepage === "inactive" && !invoiceCheck && (
            <>
              <div className="datatable-pagination">
                Rows per page
                <div className="ms-2 form-control w-auto">
                  <select
                    value={itemsPerPage1}
                    onChange={(e) => {
                      setItemsPerPage1(Number(e.target.value));
                    }}
                    className="Pagenation-Select"
                  >
                    <option value="30">
                      <div className="select-option">30</div>
                    </option>
                    <option value="50">
                      <div className="select-option">50</div>
                    </option>
                    <option value="100">
                      <div className="select-option">100</div>
                    </option>
                    <option value="500">
                      <div className="select-option">500</div>
                    </option>
                    <option value="1000">
                      <div className="select-option">1000</div>
                    </option>
                  </select>
                </div>
                <button
                  onClick={prevPage1}
                  disabled={currentPage1 === 1}
                  className="btn btn-link datatable-pagination-button datatable-pagination-right ripple-surface-dark"
                >
                  Previous
                </button>
                <div className="d-flex justify-content-between w-140px align-items-center">
                  <span className="mx-1"> Page</span>
                  <input
                    className="form-control w-50px"
                    value={currentPage1}
                    onChange={(e) => setCurrentPage1(Number(e.target.value))}
                  />
                  <span className="mx-1">of</span>
                  {totalPages}
                </div>
                <button
                  onClick={nextPage1}
                  disabled={currentPage1 === totalPages}
                  className="btn btn-link datatable-pagination-button datatable-pagination-right ripple-surface-dark"
                >
                  Next
                </button>
              </div>
            </>
          )}

          {activepage === "partnerGym" && !invoiceCheck && (
            <div className="datatable-pagination">
              Rows per page
              <div className="ms-2 form-control w-auto">
                <select
                  value={itemsPerPage}
                  onChange={(e) => {
                    setItemsPerPage(Number(e.target.value));
                    setCurrentPage(1);
                  }}
                  className="Pagenation-Select"
                >
                  <option value="30">30</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="500">500</option>
                  <option value="1000">1000</option>
                </select>
              </div>
              <button
                onClick={prevPage}
                disabled={currentPage === 1}
                className="btn btn-link datatable-pagination-button datatable-pagination-right ripple-surface-dark"
              >
                Previous
              </button>
              <div className="d-flex justify-content-between w-120px align-items-center">
                {" "}
                Page
                <input
                  className="form-control w-50px"
                  value={currentPage}
                  onChange={(e) => setCurrentPage(Number(e.target.value))}
                />
                of {totalPages}
              </div>
              <button
                onClick={nextPage}
                disabled={currentPage === totalPages}
                className="btn btn-link datatable-pagination-button datatable-pagination-right ripple-surface-dark"
              >
                Next
              </button>
            </div>
          )}
        </div>
      )}

      {!invoiceCheck && (
        <>
          {openAttendance && (
            <Popup
              title="Attendance"
              ptype="modal-lg"
              content={
                <>
                  <div>
                    <AttendanceList
                      id={selectedId}
                      data={selData}
                      oncancel={closeLogTime}
                      onsave={checkMember}
                      onclose={closeAttenance}
                      expires={
                        getExpiryDate(selData).includes("Expired (Overdue)")
                          ? "Expired(Overdue) "
                          : getExpiryDate(selData).includes("Expired")
                            ? "Expired"
                            : getExpiryDate(selData).includes("No Plan")
                              ? "No Plan Associated"
                              : `Expires:${getExpiryDate(selData)}`
                      }
                      backallback={closeAttenance}
                      submit="0"
                    />
                  </div>
                </>
              }
              handleClose={closeAttenance}
            />
          )}
          {logtimeShow && (
            <SubPopup
              title={value != null ? value : "Log Time"}
              ptype="modal-md"
              content={
                <>
                  <div>
                    <LogATime
                      id={selectedId}
                      data={selData}
                      value={value}
                      oncancel={closeLogTime}
                      expires={
                        getExpiryDate(selData).includes("Expired (Overdue)")
                          ? "Expired(Overdue) "
                          : getExpiryDate(selData).includes("Expired")
                            ? "Expired"
                            : getExpiryDate(selData).includes("No Plan")
                              ? "No Plan Associated"
                              : `Expires:${getExpiryDate(selData)}`
                      }
                      onsave={checkMember}
                    />
                  </div>
                </>
              }
              handleClose={closeLogTime}
            />
          )}
        </>
      )}
    </>
  );
};
export default Check;